import "./TestLatestNews.css";
import { newsData } from "../../../data/news-data";

/* Same image source as old home (home-latestnews.js): item.image800 || item.image400 || item.image from news-data */

const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
    <path
      d="M3 8h10M9 4l4 4-4 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FALLBACK_GRADIENT = "linear-gradient(135deg, #0C1F3F 0%, #142d54 50%, #1a4a7a 100%)";

/** Format date from news-data (e.g. "22-10-15") to display (e.g. "15 October 2022") */
function formatDate(dateStr) {
  if (!dateStr) return "";
  const [yy, mm, dd] = dateStr.split("-");
  if (!dd || !mm || !yy) return dateStr;
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const m = months[parseInt(mm, 10) - 1];
  const y = yy.length === 2 ? `20${yy}` : yy;
  return `${dd} ${m} ${y}`;
}

/** Same link logic as old home: id → /news/:id, else item.link */
function getNewsLink(item) {
  if (item.id) return `/news/${item.id}`;
  if (item.link) return item.link;
  return "/news";
}

export default function TestLatestNews() {
  const data = newsData || [];
  const featured = data[0];
  const sideArticles = data.slice(1);

  if (data.length === 0) {
    return (
      <section className="th-news">
        <div className="th-news-inner">
          <h2 className="th-news-title">Latest News & Updates</h2>
          <p className="th-news-feat__text">No news at the moment.</p>
        </div>
      </section>
    );
  }

  const featuredHref = getNewsLink(featured);
  const featuredImg = featured.image800 || featured.image400 || featured.image;

  return (
    <section className="th-news">
      <div className="th-news-inner">
        <div className="th-news-top">
          <h2 className="th-news-title">Latest News & Updates</h2>
          <a href="/news" className="th-news-vl">View All <ArrowIcon /></a>
        </div>
        <div className="th-news-grid">
          <a href={featuredHref} className="th-news-feat">
            <div className="th-news-feat__img">
              <img
                src={featuredImg}
                alt={featured.title ?? ""}
                style={{ background: FALLBACK_GRADIENT }}
                onError={(e) => { e.target.onerror = null; e.target.src = ""; e.target.style.background = FALLBACK_GRADIENT; }}
              />
            </div>
            <div className="th-news-feat__body">
              <div className="th-news-feat__date">{formatDate(featured.date)}</div>
              <h3 className="th-news-feat__title">{featured.title}</h3>
              <p className="th-news-feat__text">{featured.minidescription ?? ""}</p>
              <span className="th-news-feat__cta">Read Article <ArrowIcon /></span>
            </div>
          </a>
          <div className="th-news-side">
            {sideArticles.map((item, i) => {
              const href = getNewsLink(item);
              const imgSrc = item.image800 || item.image400 || item.image;
              return (
                <a key={item.id ?? i} href={href} className="th-news-sc">
                  <div className="th-news-sc__img" style={{ background: "#142d54" }}>
                    <img src={imgSrc} alt={item.title ?? ""} onError={(e) => { e.target.style.display = "none"; }} />
                  </div>
                  <div className="th-news-sc__body">
                    <div className="th-news-sc__date">{formatDate(item.date)}</div>
                    <h4 className="th-news-sc__title">{item.title}</h4>
                    <p className="th-news-sc__text">{item.minidescription ?? ""}</p>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
